import { createApiClient } from 'Network/ApiClient';

export const ActivityNotAllowedICDAxiosInstance = createApiClient('ActivityNotIcd/');


